import type { DiceRollMessage as DiceRollMessageType } from '@/types'

interface DiceRollMessageProps {
  roll: DiceRollMessageType
  currentUserId: string
}

/**
 * Dice-roll message — outer `.ac-chat-msg` row (gets `.is-self` /
 * `.is-whisper` like a normal chat message) with the v5 `.ac-roll`
 * card embedded in the body. Roll layout: notation + detail breakdown
 * on the left, total as a large Balthazar mint number on the right.
 */
export function DiceRollMessage({ roll, currentUserId }: DiceRollMessageProps) {
  const isOwnRoll = roll.userId === currentUserId
  const timestamp = new Date(roll.timestamp).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  })

  const rowClasses = [
    'ac-chat-msg',
    isOwnRoll && 'is-self',
    roll.isWhisper && 'is-whisper',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={rowClasses}>
      <div className="head">
        <span className="author">{roll.displayName}</span>
        <span>{timestamp}</span>
        {roll.isWhisper && (
          <span className="font-mono-ac" style={{ color: 'hsl(265 40% 70%)' }}>
            → whisper
          </span>
        )}
      </div>
      <div className="ac-roll">
        <div className="notation">
          {roll.label ? (
            <>
              <span style={{ color: 'hsl(var(--ac-mint-primary))' }}>
                {roll.label}:
              </span>{' '}
              {roll.notation}
            </>
          ) : (
            roll.notation
          )}
        </div>
        <div className="detail">{roll.output}</div>
        <div className="total">{roll.total}</div>
      </div>
    </div>
  )
}
